import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { CoreConfigService } from "../../../@core/services/config.service";

@Injectable({
  providedIn: "root",
})

export default class UserOptionsService {
  constructor(private http: HttpClient, private coreConfig: CoreConfigService) {
  }

  list() {
    return this.http.get("/user-options")
      .pipe(
        tap((data: any) => {
          const layout = { ...this.coreConfig.localConfig.layout, ...data };
          this.coreConfig.setConfig({ layout }, { emitEvent: true });
          return data;
        }),
      );
  }

  set(name: string, value: any) {
    return this.http.patch(`/user-options/${name}`, value)
      .pipe((data) => {
        const layout = {};
        layout[name] = value;
        this.coreConfig.setConfig({ layout }, { emitEvent: true });
        return data;
      });
  }
}